import React, { useState } from "react"
import { X } from "lucide-react"

// mode: "single" | "bulk". initial optional { discount_type, discount_value }
const DiscountModal = ({ open, onClose, onSubmit, onRemove, initial, mode = "single" }) => {
  const [type, setType] = useState(initial?.discount_type || "percent")
  const [value, setValue] = useState(initial?.discount_value?.toString() || "")

  if (!open) return null

  const handleSubmit = (e) => {
    e.preventDefault()
    const num = parseFloat(value)
    if (isNaN(num) || num < 0) return
    if (type === "percent" && num > 100) return
    onSubmit({ discount_type: type, discount_value: num })
  }

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/30 p-4">
      <div className="bg-white rounded-2xl shadow-lg w-full max-w-sm p-5">
        <div className="flex items-center justify-between mb-4">
          <h3 className="text-base font-semibold text-[#1F2733]">
            {mode === "bulk" ? "Скидка на всю сессию" : "Скидка на тур"}
          </h3>
          <button onClick={onClose} className="text-[#9AA5B4] hover:text-[#5A6779]">
            <X size={18} />
          </button>
        </div>

        <form onSubmit={handleSubmit} className="flex flex-col gap-4">
          <div className="flex gap-2">
            <button
              type="button"
              onClick={() => setType("percent")}
              className={`flex-1 text-sm rounded-lg border px-3 py-2 ${
                type === "percent"
                  ? "border-[#26303D] bg-[#26303D] text-white"
                  : "border-[#E7EAEF] text-[#5A6779]"
              }`}
            >
              % Процент
            </button>
            <button
              type="button"
              onClick={() => setType("fixed")}
              className={`flex-1 text-sm rounded-lg border px-3 py-2 ${
                type === "fixed"
                  ? "border-[#26303D] bg-[#26303D] text-white"
                  : "border-[#E7EAEF] text-[#5A6779]"
              }`}
            >
              Фикс. сумма
            </button>
          </div>

          <input
            type="number"
            min="0"
            max={type === "percent" ? 100 : undefined}
            step="0.01"
            value={value}
            onChange={(e) => setValue(e.target.value)}
            placeholder={type === "percent" ? "например, 10" : "например, 3000"}
            className="border border-[#E7EAEF] rounded-lg px-3 py-2 text-sm font-mono"
            autoFocus
          />

          <div className="flex items-center justify-between gap-2 mt-1">
            {initial?.discount_type && onRemove && (
              <button
                type="button"
                onClick={onRemove}
                className="text-xs text-[#E0554F] hover:underline"
              >
                Убрать скидку
              </button>
            )}
            <div className="flex gap-2 ml-auto">
              <button type="button" onClick={onClose} className="text-sm text-[#5A6779] px-3 py-2">
                Отмена
              </button>
              <button
                type="submit"
                className="text-sm text-white bg-[#26303D] rounded-lg px-4 py-2"
              >
                Применить
              </button>
            </div>
          </div>
        </form>
      </div>
    </div>
  )
}

export default DiscountModal
